
import OurServicesComponent  from '../components/ourServicesComponent';


function Services() {

    return (
        <div
            style={{
                minHeight: '100vh',
                width: '100vw',
                padding: '2rem',
                textAlign: 'center',
                backgroundColor: '#F5F5DC',
                boxSizing: 'border-box',
             display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '2rem'
            }}
        >
        <OurServicesComponent />

        </div>
    );
}

export default Services;